const styles = {
  date: {
    '&.MuiTypography-quote': {
      color: 'common.purple',
    },
  },
  quote: {
    '&.MuiTypography-quote': {
      color: 'common.white',
      fontSize: '10px',
    },
  },
  tile: {
    backgroundColor: 'background.default',
    paddingX: 0.5,
    borderRadius: '0px!important',
    '& .Tile-text': {
      padding: '2px 2px!important',
      fontSize: '12px!important',
    },
    '&.promotion': {
      backgroundColor: 'background.blue',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_hold': {
      backgroundColor: 'text.grey200',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_hold_online': {
      backgroundColor: 'text.grey200',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_archived': {
      backgroundColor: 'error.main',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_available': {
      height: 'fit-content',
      backgroundColor: 'background.blue',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_hotsale': {
      backgroundColor: 'text.alert',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_proximo': {
      backgroundColor: '#135FC4',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_discount': {
      backgroundColor: '#DD1E33',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_discountyear': {
      backgroundColor: '#8C46ED',
      '& span': {
        color: '#fff',
      },
    },
    '&.status_discountGoBack': {
      backgroundColor: '#09C7A6',
      '& span': {
        color: '#fff',
      },
    },
    '&.consignacion': {
      backgroundColor: 'common.secondaryEasy',
      '& span': {
        color: '#343434',
      },
    },
    '&.greenBG': {
      backgroundColor: '#09C7A6',
      '& .MuiTypography-strong': {
        color: '#fff!important',
        fontWeight: 400,
      },
      '& svg path': {
        fill: '#fff!important',
      },
    },
    '&.colorBlack': {
      '& .MuiTypography-root': {
        color: '#000',
      },
    },
  },
  peopleAction: (color) => ({
    '&.MuiTypography-strong': {
      color,
    },
  }),
}

export default styles
